import React, { useState, useEffect } from "react";
import GateControlFooter from "./GateControl";

const ResponsiveGateControl = ({ area }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <GateControlFooter area={area} embedded={!isMobile} />
  );
};

export default ResponsiveGateControl;
